import { useTranslation } from 'react-i18next';

import { OpCard } from 'new-components/DLS/OpCard/OpCard';

import { VideoDeviceType } from '../../../../../types/videoDeviceTypes';

interface DeviceCardProps {
  device: VideoDeviceType;
  imageUrl: string;
  onSelect: (device: VideoDeviceType) => void;
}

const DeviceCard = ({ device, imageUrl, onSelect }: DeviceCardProps) => {
  const { t } = useTranslation();

  const hasVideoError = device.errors?.length > 0;

  return (
    <OpCard
      style={{
        marginBottom: 24,
        cursor: hasVideoError || !imageUrl ? 'not-allowed' : 'pointer',
      }}
      onClick={() => !hasVideoError && imageUrl && onSelect(device)}
    >
      <div>
        <div
          style={{ fontWeight: 600, textAlign: 'center', paddingBottom: 10 }}
        >
          {device.name}
        </div>
        {hasVideoError || !imageUrl ? (
          <div
            style={{
              width: '101%',
              height: 85,
              display: 'flex',
              background: 'var(--colorTextTertiary)',
              borderRadius: 6,
              justifyContent: 'center',
              alignItems: 'center',
              color: 'var(--colorWhite)',
            }}
          >
            {t('visitors.profile.videoLog.modal.noVideo')}
          </div>
        ) : (
          <img
            src={imageUrl}
            alt="thumbnail"
            style={{
              width: '101%',
              height: 85,
              objectFit: 'contain',
              background: '#000',
              borderRadius: 6,
            }}
          />
        )}
      </div>
    </OpCard>
  );
};

export default DeviceCard;
